import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';
import { environment } from '../../../environments/environment';
import { LoaderEvent } from '../../shared/message.event';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { CONSTANT_VALUES } from '../../constants/constant-values';

@Component({
  selector: 'app-download-template',
  templateUrl: './download-template.component.html',
  styleUrls: ['./download-template.component.css'],
  exportAs: 'downloadTemplate'
})
export class DownloadTemplateComponent implements OnInit {
  @ViewChild('childModal') childModal: ModalDirective;
  /*private bookingCsvPath = CONSTANT_VALUES.BOOKING_CSV_PATH_UAT;
  private membersCsvPath = CONSTANT_VALUES.MEMBER_CSV_PATH_UAT;*/
  private stringConstants = CONSTANT_MESSAGES;
  @ViewChild('fileUploadInput')
  fileUploadInputVariable: any;

  @ViewChild('fileUploadBlockSlot')
  fileUploadBlockSlot: any;

  // @ViewChild('bookingFileUploadInput')
  // fileBookingUploadInputVariable: any;

  @Output() upload = new EventEmitter<any>();
  @Output() uploadBlock = new EventEmitter<any>();
  constructor() { }

  ngOnInit() {
  }

  public showChildModal(failureList, successList): void {
    this.resetFileUploadInput();
    this.resetFileBlockSlot();
    //this.resetFileBookingUploadInput();
    this.stringConstants = CONSTANT_MESSAGES;
    this.childModal.config.backdrop = false;
    this.childModal.config.keyboard = false;
    //this.setTemplateUrlByEnvironment();
    this.childModal.show();

  }

  public hideChildModal(): void {
    this.childModal.hide();
  }

  uploadBookingFile(event) {
    this.childModal.hide();
    let obj = {
      event: event,
      flag: true
    }
    this.upload.emit(obj);

  }
  uploadMemberFile(event) {
    this.childModal.hide();
    let obj = {
      event: event,
      flag: false
    }
    this.upload.emit(obj);
  }
  /*setTemplateUrlByEnvironment() {
    switch (environment.envName) {
      case 'dev':
        this.bookingCsvPath = CONSTANT_VALUES.BOOKING_CSV_PATH;
        this.membersCsvPath = CONSTANT_VALUES.MEMBER_CSV_PATH;
        break;
      case 'qa':
        this.bookingCsvPath = CONSTANT_VALUES.BOOKING_CSV_PATH_QA;
        this.membersCsvPath = CONSTANT_VALUES.MEMBER_CSV_PATH_QA;
        break;
      case 'uat':
        this.bookingCsvPath = CONSTANT_VALUES.BOOKING_CSV_PATH_UAT;
        this.membersCsvPath = CONSTANT_VALUES.MEMBER_CSV_PATH_UAT;
        break;
      case 'prod':
        this.bookingCsvPath = CONSTANT_VALUES.BOOKING_CSV_PATH_PROD;
        this.membersCsvPath = CONSTANT_VALUES.MEMBER_CSV_PATH_PROD;
        break;
    }
  }*/

  resetFileUploadInput() {
    this.fileUploadInputVariable.nativeElement.value = '';
  }
  resetFileBlockSlot() {
    this.fileUploadBlockSlot.nativeElement.value = '';
  }

  // resetFileBookingUploadInput() {
  //   this.fileBookingUploadInputVariable.nativeElement.value = '';
  // }
  uploadBlockFile(event) {
    this.childModal.hide();
    this.uploadBlock.emit(event);
  }
}



// WEBPACK FOOTER //
// ./src/app/member/download-template/download-template.component.ts